import React from 'react'

function SearchImg() {
    return (
        <svg
            width="52"
            height="48"
            viewBox="0 0 52 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label="search-icon"
        >
            <path
                d="M0 0H44C48.4183 0 52 3.58172 52 8V40C52 44.4183 48.4183 48 44 48H0V0Z"
                fill="#FF640A"
            />
            <path
                d="M29.5137 29.5142L35.1705 35.171"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.8919 28.8935C31.7733 26.0121 31.7733 21.3405 28.8919 18.4591C26.0105 15.5777 21.3388 15.5777 18.4574 18.4591C15.5761 21.3405 15.5761 26.0121 18.4574 28.8935C21.3388 31.7748 26.0105 31.7748 28.8919 28.8935Z"
                stroke="black"
                strokeWidth="3"
            />
        </svg>
    )
}

export default SearchImg
